import React from 'react';
import { Badge } from 'react-bootstrap';
import customOrderService from '../../../services/customOrderService';

/**
 * ✅ ATELIER: Badge d'affichage d'un statut de commande.
 */
const OrderStatusBadge = ({ status, size = 'normal', showIcon = true }) => {
  const info = customOrderService.getStatusInfo(status);

  return (
    <Badge
      bg={info.color}
      className={size === 'small' ? 'small-badge' : ''}
      style={{
        fontSize: size === 'small' ? '0.7rem' : '0.8rem',
        padding: size === 'small' ? '0.3em 0.6em' : '0.4em 0.8em',
        fontWeight: 600
      }}
    >
      {showIcon && <span className="me-1">{info.icon}</span>}
      {info.label}
    </Badge>
  );
};

export default OrderStatusBadge;